import VState from 'signal/v-state'

const acceptStorageState = new VState(false)

export default acceptStorageState